import { render, staticRenderFns } from "./DisqualificationDestroyApply.vue?vue&type=template&id=3f3d38d3"
import script from "./DisqualificationDestroyApply.vue?vue&type=script&lang=js"
export * from "./DisqualificationDestroyApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports